import { CountrySelector, Select } from "@tfg/ui"
import _ from "lodash"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"
import { removeUndefined } from "@tfg/types/schemas/utils"

import { useFindProductSupplierContactValues } from "~/gen/api"
import { COUNTRIES } from "~/utils/countries"

export type Props = {
  setFiltersValue: (value: filtersValidationType) => void
  filtersValue: filtersValidationType
}
export function SupplierInfoSelector({ setFiltersValue, filtersValue }: Props) {
  const { t } = useTranslation("products")

  const { data: supplierContactValues, isLoading } =
    useFindProductSupplierContactValues({
      ...removeUndefined(filtersValue),
    })

  const companies = _.uniqBy(
    supplierContactValues?.data.map((supplier) => supplier.company),
    "id"
  )

  const countries = _.uniq(
    supplierContactValues?.data.map((supplier) => supplier.company.country)
  )

  return (
    <>
      <Select
        data={companies.map((company) => ({
          value: company.id,
          label: company.name,
        }))}
        placeholder={t("lists.placeholders.companies")}
        value={filtersValue.companyId ?? null}
        onChange={(value) =>
          setFiltersValue({
            ...filtersValue,
            companyId: value === null ? undefined : value,
          })
        }
        isLoading={isLoading}
        searchable
        clearable
      />
      <CountrySelector
        value={filtersValue.country ?? null}
        countriesMapper={COUNTRIES}
        isLoading={isLoading}
        onChange={(value) =>
          setFiltersValue({
            ...filtersValue,
            country:
              value === null
                ? undefined
                : (value as filtersValidationType["country"]),
          })
        }
        selectCountries={countries}
        size="xs"
        searchable
        clearable
        placeholder={t("lists.placeholders.country")}
      />
    </>
  )
}
